import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../../shared/shared.module';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

import { IndicadoresVivosRoutingModule } from './indicadores-vivos-routing.module';
import { IndicadoresVivosHomeComponent } from './views/indicadores-vivos-home/indicadores-vivos-home.component';
import { UploadCsvIndicadoresComponent } from './views/upload-csv-indicadores/upload-csv-indicadores.component';
import { ReporteIndicadoresComponent } from './views/reporte-indicadores/reporte-indicadores.component';
import { MantenedorIndicadoresComponent } from './views/mantenedor-indicadores/mantenedor-indicadores.component';
import { CambioPresupuestoComponent } from './views/cambio-presupuesto/cambio-presupuesto.component';
import { MantenedorDireccionesComponent } from './views/mantenedor-direcciones/mantenedor-direcciones.component';
import { MantenedorDireccionesUsuariosComponent } from './views/mantenedor-direcciones-usuarios/mantenedor-direcciones-usuarios.component';
import { RegistroDeVersionesComponent } from './views/registro-de-versiones/registro-de-versiones.component';
import { UploadCsvFacturasMarcasComponent } from './views/upload-csv-facturas-marcas/upload-csv-indicadores.component';
import { MantenedorFacturasMarcasComponent } from './views/mantenedor-facturas-marcas/mantenedor-facturas-marcas.component';
import { UploadCsvSellOutComponent } from './views/upload-csv-sell-out/upload-csv-sell-out.component';
import { MantenedorSellOutComponent } from './views/mantenedor-sell-out/mantenedor-sell-out.component';
import { TipoDeVendedorComponent } from './views/tipo-de-vendedor/tipo-de-vendedor.component';
import { UploadPresupuestoPropiedaesComponent } from './views/upload-presu-propiedades/upload-presu-propiedades.component';
import { MantenedorPresuJerarquiaComponent } from './views/mantenedor-presu-propiedades/mantenedor-presu-propiedades.component';
import { UploadPresupuestoPromocionalComponent } from './views/upload-presupuesto-promocional/upload-presupuesto-promocional.component';
import { ReportePresupuestoPromocionalComponent } from './views/reporte-presupuesto-promocional/reporte-presupuesto-promocional.component';


@NgModule({
    declarations: [
    IndicadoresVivosHomeComponent,
    UploadCsvIndicadoresComponent,
    UploadCsvSellOutComponent,
    ReporteIndicadoresComponent,
    MantenedorIndicadoresComponent,
    MantenedorSellOutComponent,
    CambioPresupuestoComponent,
    MantenedorDireccionesComponent,
    RegistroDeVersionesComponent,
    TipoDeVendedorComponent,
    UploadCsvFacturasMarcasComponent,
    MantenedorFacturasMarcasComponent,
    MantenedorDireccionesUsuariosComponent,
    UploadPresupuestoPropiedaesComponent,
    MantenedorPresuJerarquiaComponent,
    UploadPresupuestoPromocionalComponent, //T25111 add presupuesto promocional
    ReportePresupuestoPromocionalComponent,//T25111 add presupuesto promocional
  ],
    exports: [
      IndicadoresVivosHomeComponent
    ],
    imports: [
      CommonModule,
      IndicadoresVivosRoutingModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ]
  })
export class IndicadoresVivosModule {}